module.exports = __webpack_public_path__ + "static/img/nongJi_details.8accb163.jpg";